import { render } from "./ArticlesView.vue?vue&type=template&id=a52a4362"
import script from "./ArticlesView.vue?vue&type=script&lang=ts"
export * from "./ArticlesView.vue?vue&type=script&lang=ts"
script.render = render

export default script